"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanString = void 0;
/**
 * Removes all whitespace, and uppercases it. Used for comparisons.
 * @param str The string to clean.
 */
function cleanString(str) {
    return str.replace(/\s/g, '').toUpperCase();
}
exports.cleanString = cleanString;
//# sourceMappingURL=cleanString.js.map